// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import { BASE_URL } from '../keys'
// import { chatApi } from './chatApi';
// export const planApi = createApi({
//     reducerPath: "planApi",
//     baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
//     endpoints: (builder) => ({
//         getPlanList: builder.query({
//             query: (categoryId) => ({
//                 url: `client/plan-list/?category=${categoryId}`,
//                 headers: {
//                     "Authorization": "Bearer " + localStorage.getItem('livtoken')
//                 },
//             })
//         }),
//        planPurchase: builder.mutation({
//   query: (data) => {
//     const formData = new FormData();
//     formData.append('category_id', data.category_id);
//     formData.append('plan_id', data.plan_id);
//     formData.append('booking_id', data.booking_id);
//     formData.append('coach_id', data.coach_id);

//     return {
//       url: 'client/purchase-plan-initiation/',
//       method: 'POST',
//       body: formData,
//        headers: {
//                     "Authorization": "Bearer " + localStorage.getItem('livtoken')
//                 },
//     };
//   },
// }),
// freeBooking:builder.mutation({
//     query:(data)=>{
//    const formData = new FormData();
//     formData.append('category_id', data.category_id);
//     formData.append('date', data.date);
//     formData.append('time_slot', data.time_slot);
//     formData.append('coach_id', data.coach_id);
//  formData.append('plan_reservation_id', data.plan_reservation_id);
//     return {
//       url: 'client/book-free-consultation/',
//       method: 'POST',
//       body: formData,
//        headers: {
//                     "Authorization": "Bearer " + localStorage.getItem('livtoken')
//                 },
//     }    
//     },
//     async onQueryStarted(arg, { dispatch, queryFulfilled }) {
//         try {
//           await queryFulfilled;
//           dispatch(districtApi.util.invalidateTags(["UserInChat"]));
//         } catch (error) {
//           console.error("Failed to update service category", error);
//         },

       
//     })
// })

// export const { useGetPlanListQuery,usePlanPurchaseMutation,useFreeBookingMutation } = planApi

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../keys';


export const planApi = createApi({
  reducerPath: "planApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getPlanList: builder.query({
      query: ({categoryID,currencyID}) => ({
        url: `client/plan-list/?category=${categoryID}&currency=${currencyID}`,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('livtoken')
        },
      }),
    }),

    planPurchase: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append('category_id', data.category_id);
        formData.append('plan_id', data.plan_id);
        formData.append('booking_id', data.booking_id);
        formData.append('coach_id', data.coach_id);
        formData.append('currency_id',data.currency_id)
        return {
          url: 'client/purchase-plan-initiation/',
          method: 'POST',
          body: formData,
          headers: {
            Authorization: "Bearer " + localStorage.getItem('livtoken')
          },
        };
      },
    }),

    // freeBooking: builder.mutation({
    //   query: (data) => {
    //     const formData = new FormData();
    //     formData.append('category_id', data.category_id);
    //     formData.append('date', data.date);
    //     formData.append('time_slot', data.time_slot);
    //     formData.append('coach_id', data.coach_id);
    //     formData.append('plan_reservation_id', data.plan_reservation_id);

    //     return {
    //       url: 'client/book-free-consultation/',
    //       method: 'POST',
    //       body: formData,
    //       headers: {
    //         Authorization: "Bearer " + localStorage.getItem('livtoken')
    //       },
    //     };
    //   },
    //   async onQueryStarted(arg, { dispatch, queryFulfilled }) {
    //     try {
    //       await queryFulfilled;
    //       dispatch(chatApi.util.invalidateTags(["UserInChat"]));
    //     } catch (error) {
    //       console.error("Failed to update service category", error);
    //     }
    //   },
    // }),
  }),
});

export const {
  useGetPlanListQuery,
  usePlanPurchaseMutation,
//   useFreeBookingMutation,
} = planApi;